import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './AilsaBayStorybook.css';
import goIcon from '../../img/featured-imgs/go-icon.svg';

class AilsaBayStorybook extends Component {
  render() {
    return (
      <div className="ailsa-bay-storybook">

        <Grid>
          <Fade>
            <Row>
              <Col md={12}>
                <h1 className="page-title"> Ailsa Bay Storybook</h1>
                <h3 className="page-description">
                  Distilled with craft, refined by code.
                </h3>
              </Col>
            </Row>
          </Fade>

          <Fade delay={300}>
            <Row className="content-row">
              <Col md={3} xs={12}>
                <h3 id="heading">BACKGROUND</h3>
              </Col>
              <Col md={9} xs={12} >
                <p>
                  When William Grant & Sons built their Ailsa Bay distillery in 2007 they had a
                  vision of creating not only something new, but something truly unique. Built
                  next to their existing distillery in Girvan, their goal was to marry 150 years
                  of experience in whisky production with a state-of-the-art laboratory, to create
                  an innovation program of new product development. The Ailsa Bay single malt is a
                  result of this vision.
                </p>
                <p>
                  With exacting precision, Ailsa Bay brings whisky-craft and innovation to a new
                  level with its singular vision: The creation of a precision-distilled single malt,
                  perfectly balanced between smoke and sweetness. Ailsa Bay not only records the
                  measurement of peat parts per million (PPPM) to determine the “peatiness” of the
                  whisky but is the first whisky to have an analysed measurement
                  of sweetness identified (SPPM). This attention to detail gives Ailsa Bay the
                  perfect balance between the peat and sweetness.
                </p>
              </Col>
            </Row>
          </Fade>
        </Grid>
        <Fade delay={300}>
          <Grid fluid>
            <Row className="quote-row">
              <Col md={10} xs={12} mdOffset={1}>
                <h2 className="quote">
                  “No other whisky is made with this much science. Using data points to adapt
                  the flavour and applying modern engineering alongside our family’s traditional
                  approach is truly innovative.”
                </h2>
                <h4>Stuart Watts, Distillery Manager, Ailsa Bay</h4>
              </Col>
            </Row>
          </Grid>
        </Fade>
        <Grid fluid>
          <Row className="solution-image-row">
            <Fade delay={200}>
              <Col md={6}>
                <div className="featured-image landing" />
              </Col>
            </Fade>
            <Fade delay={500}>
              <Col md={6}>
                <div className="featured-image story" />
              </Col>
            </Fade>
          </Row>
        </Grid>
        <Fade>
          <Grid>
            <Row className="content-row">
              <Col md={3} xs={12}>
                <h3 id="heading">SOLUTION</h3>
              </Col>
              <Col md={9} xs={12}>
                <p>
                  Having utilised whisky-craft and innovation to create Ailsa Bay, William Grant
                  turned to technology, and arc-net, to help them share the story of their unique
                  single malt with their customers. Ailsa Bay has been produced and bottled
                  utilising Distilled ID, arc-net’s unique blockchain-backed distillery management
                  platform.
                </p>
                <p>
                  Each bottle of Ailsa Bay single malt is individually marked with a unique QR code.
                  Scanning that code takes the customer to a rich interactive storybook experience
                  through which they can learn a variety of details about their specific bottle
                  including its number in the batch, malting, mashing, fermentation, distillation,
                  and maturation processes.
                </p>
                <p>
                  Distilled ID stores operational data on a private blockchain, ensuring it
                  is secure and immutable, providing William Grant with the confidence, and
                  ability, to share every aspect of the Ailsa Bay story and engage directly
                  with their consumers. For the consumer, Distilled ID, not only provides the
                  scientific facts and tasting notes specific to their bottle of Ailsa Bay but
                  also provides the trust and transparency in the bottle they have purchased.
                </p>
                <p>
                  In addition to the wealth of inside knowledge, the Ailsa Bay Storybook also
                  provides consumers with a unique interactive experience, through which they
                  must use accuracy and timing in order to decode the exact PPPM and SPPM values
                  of their bottle. A defining trait of Ailsa Bay.
                </p>
              </Col>
            </Row>
          </Grid>
        </Fade>
        <Fade>
          <Grid fluid>
            <Row className="quote-row">
              <Col md={10} xs={12} mdOffset={1}>
                <h2 className="quote">
                  ”Arc-net are delighted to be supporting William Grant’s “Free Spirit”
                  initiative. The scientific approach, and the use of data, in the production
                  of Ailsa Bay single malt is truly innovative and aligns perfectly with the
                  ethos of arc-net. The true value of Distilled ID comes from our unique
                  ability to connect products and customers and we look forward to providing
                  the platform for William Grant and their customers to appreciate each
                  other even more.”
                </h2>
                <h4> Drew Lyall, General Manager of arc-net</h4>
              </Col>
            </Row>
          </Grid>
        </Fade>
        <Fade>
          <Grid>
            <Row className="content-row">
              <Col md={3} xs={12}>
                <h3>OUTCOME</h3>
              </Col>
              <Col md={9} xs={12}>
                <p>
                  Through the implementation of Distilled ID, William Grant are able to
                  demonstrate their commitment to craft, innovation and technology, both
                  in the production of Ailsa Bay single malt and by providing their customers
                  with the opportunity to understand the science behind their dram.
                </p>
                <p>
                  Providing customers with the ability to scan their bottle and learn how
                  science and technology are enhancing traditional whisky production, provides
                  a unique experience and builds trust in their brand.
                </p>
                <p>
                  Distilled ID has allowed William Grant to build their unique story, share
                  it with their customers and have complete traceability from field to bottle
                  to customer.  It not only provides valuable consumer intelligence, it
                  connects William Grant directly with the end consumers of their product,
                  facilitating the possibility of a stronger, longer-lasting relationship.
                </p>
              </Col>
            </Row>
          </Grid>
        </Fade>
        <Grid fluid>
          <Fade>
            <Row>
              <a
                className="case-study-download"
                target="_blank"
                rel="noopener noreferrer"
                href="https://s3-eu-west-1.amazonaws.com/distilled-id/static/media/Distilled-ID-Ailsa-Bay-Case-Study.pdf">
                <div className="download-pdf-container">
                  <h3>View this case study as a PDF</h3>
                </div>
              </a>
            </Row>
          </Fade>
          <Fade>
            <Row className="social-row">
              <Col md={10} xs={12} mdOffset={1}>
                <h5>
                  SHARE
                </h5>
                <div className="social-links">
                  <a href="https://twitter.com/share?hashtags=%23distilledID" className="link">Twitter</a>
                  <a href="http://www.linkedin.com/shareArticle?title=%23distilledID" className="link">LinkedIn</a>
                  <a href="https://www.facebook.com/sharer.php?s=100" className="link">Facebook</a>
                </div>
              </Col>
            </Row>
          </Fade>
          <Row className="post-navigation">
            <Col className="buttons-container">
              <Col md={6} sm={6} xs={6}>
                <Link to="/case_studies/irelandcraftbeers" className="case-study-link">
                  <div className="navigation-control navigation-next">
                    <div className="nav-content" id="right">
                      <div>
                        <span>Next</span>
                        <h3>Ireland craft beers - Downstream</h3>
                      </div>
                      <div className="arrow-right">
                        <img src={goIcon} alt="next" className="arrow-img" id="arrow-right" />
                      </div>
                    </div>
                  </div>
                </Link>
              </Col>
            </Col>
          </Row>
        </Grid>
      </div>

    );
  }
}

export default AilsaBayStorybook;



// WEBPACK FOOTER //
// ./src/components/common/AilsaBayStorybook.js